var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"more"},[_c('div',_vm._l((_vm.item),function(item){return _c('ul',{key:item.id,staticClass:"myUL"},[_c('li',{on:{"click":function($event){return _vm.jump(item)}}},[_vm._v(_vm._s(item.menuName))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b78935b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/more.vue
// module id = null
// module chunks = 